<template>
  <div id="month_statistics">
    <van-nav-bar
      :title="$t('title.month_statistics')"
      :right-text="$t('title.month_statistics_log')"
      safe-area-inset-top
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <van-row>
      <van-col span="22" offset="1">
        <img src="../assets/img/bg_slices.png" class="month_statistics_img"/>
      </van-col>
      <van-col span="22" offset="1" class="month_statistics_today"> {{ $t('column.today')}} </van-col>
      <van-col span="22" offset="1" class="month_statistics_today_type">
        <van-col span="24" class="month_statistics_today_type_bor">
          <van-col span="12" class="month_statistics_today_type_coin"> {{ $t('other.profit') }} </van-col>
          <van-col span="12" class="month_statistics_today_type_sum"> {{ today.earnings }} </van-col>
        </van-col>
        <van-col span="24">
          <van-col span="12" class="month_statistics_today_type_coin"> {{ $t('column.Live_durntion') }} </van-col>
          <van-col span="12" class="month_statistics_today_type_sum">{{ today.duration }} </van-col>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="month_statistics_today"> {{ $t('column.this_month') }} </van-col>
      <van-col span="22" offset="1" class="month_statistics_today_type">
        <van-col span="24" class="month_statistics_today_type_bor">
          <van-col span="12" class="month_statistics_today_type_coin"> {{ $t('other.profit') }} </van-col>
          <van-col span="12" class="month_statistics_today_type_sum">{{ month.earnings }} </van-col>
        </van-col>
        <van-col span="24" class="month_statistics_today_type_bor">
          <van-col span="12" class="month_statistics_today_type_coin"> {{ $t('column.Live_durntion') }} </van-col>
          <van-col span="12" class="month_statistics_today_type_sum">{{ month.duration }} </van-col>
        </van-col>

        <van-col span="24">
          <van-col span="12" class="month_statistics_today_type_coin"> {{ $t('column.Valid_live_days') }} </van-col>
          <van-col span="12" class="month_statistics_today_type_sum"> {{ month.day_effective }} {{ $t('other.days') }} </van-col>
        </van-col>
      </van-col>
      <!--  直播任务奖励    -->
      <van-col span="22" offset="1" class="month_statistics_today" v-if="is_task"> {{ $t('column.Live_streaming_task_rewards') }} </van-col>
      <van-col span="22" offset="1" class="month_statistics_today_type month_statistics_today_type_bottom" v-if="is_task">
        <van-col span="22" offset="1">
          <van-grid>
            <van-grid-item class="month_statistics_today_grid" v-for="(item,j) in task.list" :key="j">
              <van-col span="24" class="month_statistics_today_grid_img">
                <img src="../assets/img/coin2.png">
              </van-col>
              <van-col span="24" class="month_statistics_today_grid_name">{{ item.name }}</van-col>
              <van-col span="24" class="month_statistics_today_grid_money" >{{ item.money }} {{ ticket_name }}</van-col>
              <van-col span="24" class="month_statistics_today_grid_receive" v-if="item.reward_text">{{ item.reward_text }}</van-col>

            </van-grid-item>
          </van-grid>
        </van-col>

      </van-col>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
export default {
  filters: {},
  data() {
    return {
      today: {
        earnings: 0,
        duration: 0
      },
      month: {
        earnings: 0,
        duration: 0,
        day_effective: 0
      },
      task: {},
      ticket_name: undefined,
      is_task: false
    }
  },
  created() {
    this.convert();
  },
  methods: {
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    onlogin(){
      // 登录失败重新登录 user_login_status
      window.location.href="live://user/logout"
    },
    onClickRight() {
      const token = this.$route.query.token
      this.$router.push({path: '/month_statistics_log', query: {token: token}});
    },
    convert() {
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user&act=month_statistics", {
        params : {
          token: token,
          date_type: this.active === 0 ? 1 : 2
        }
      }).then(res =>{
        console.log(res.data)
        if (res.data.status === 0) {
          this.onlogin()
          Toast(res.data.error)
          return false
        }else{
          this.month = res.data.data.month
          this.today = res.data.data.today
          this.task = res.data.data.task
          this.ticket_name = res.data.data.ticket_name
          this.is_task = res.data.data.is_task
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/month_statistics.vue